import { useCallback } from "react";
import { SuppliersApi, useAPIAction } from "melco-shared-logic";

export interface PublishSupplierButtonInterface {
  id: string;
}

export const usePublishSupplier = () => {
  const [PublishSupplier] = useAPIAction(
    SuppliersApi,
    async (api, PublishSupplierData: PublishSupplierButtonInterface) => {
      const data = await api.supplierPublish({
        id: PublishSupplierData.id,
      });

      return {
        successMessages: [],
        data,
      };
    },
    { skipErrorHandling: true, translationPrefix: "" }
  );

  return useCallback(
    async (PublishActionDetails: PublishSupplierButtonInterface) => {
      return await PublishSupplier(PublishActionDetails);
    },
    [PublishSupplier]
  );
};
